import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoFileReplaceRefresh = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>FileReplaceRefresh</title>
    <path
      d="M13.784 17.426c1.785-1.785 4.72-2.041 6.464 0m-7.165-2.67-.648 3.465a.54.54 0 0 0 .463.612l3.511.317m3.68 3.928c-1.77 1.8-4.703 2.082-6.465.056m7.188 2.608.618-3.47a.54.54 0 0 0-.468-.608l-3.514-.287"
      stroke="currentColor"
      strokeWidth={1.667}
      strokeLinecap="round"
    />
    <path
      d="M26.857 12.638v14.637a2.429 2.429 0 0 1-2.43 2.43H9.57a2.429 2.429 0 0 1-2.429-2.43V6.703A2.429 2.429 0 0 1 9.57 4.274h9.253c.668 0 1.307.275 1.765.761l5.606 5.935a2.43 2.43 0 0 1 .663 1.668Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M26.713 12.416H22.14a3.429 3.429 0 0 1-3.429-3.428V4.416"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoFileReplaceRefresh;
